import * as zod from 'zod';

import { ActionRequiredError, Step } from '@sb/remote-control/types';

export namespace MiraiRunSkillStep {
  export const name = 'MIRAI Run skill';
  export const description = 'Execute a MIRAI skill on the Micropsi controller';
  export const librarySection = Step.LibrarySection.InterfaceWithMachines;
  export const librarySort = 'mirai';
  export const argumentKind = 'MiraiRunSkill';
  export const featureFlag = 'miraiRunSkill' as const;

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    miraiControllerId: zod.string().default(''),
    skillId: zod.number().nullable().default(null),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    if (!args.miraiControllerId) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'MIRAI Controller must be selected',
        fieldId: 'miraiControllerId',
      });
    }

    if (args.skillId == null || args.skillId < 0) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'A MIRAI skill must be selected',
        fieldId: 'skillId',
      });
    }

    return {
      ...stepData,
      stepKind: 'MiraiRunSkill',
      args: {
        miraiControllerId: args.miraiControllerId,
        skillId: args.skillId,
      },
    };
  };

  export const getStepDescription: Step.GetStepDescription = ({
    stepConfiguration: { args },
    includeStepName,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      return null;
    }

    return includeStepName ? 'Run MIRAI skill' : '';
  };
}

MiraiRunSkillStep satisfies Step.StepKindInfo;
